export default __webpack_public_path__ + "static/media/projectHealthLogoM.8ac1ef93.svg";